module.exports = __webpack_public_path__ + "static/media/255px_logo_bug_br.bf6c6f63.png";